import React, { useEffect, useRef } from 'react';

function Animation() {

    const star1Ref = useRef(null);
    const star2Ref = useRef(null);
    const star3Ref = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
          const value = window.scrollY;
          
          const rotationAngle = value / 10; 
          star1Ref.current.style.transform = `translateX(${value / 1.5}px)  rotate(${rotationAngle}deg)`; 
          star2Ref.current.style.transform = `translateX(${-value / 2}px)  rotate(${rotationAngle}deg)`;  
          star3Ref.current.style.transform = `translateX(${value / 1.5}px)  rotate(${rotationAngle}deg)`; 

        };
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

  return (
    <div className='mx-auto -mt-52'>
        <div ref={star1Ref} className='relative -top-10 right-[550%] md:right-[200%] xl:right-[100%]'>
            <img className='w-52 h-52' src="/Image/download.svg" alt="" />
            <h2 className='absolute top-14 left-16 font-bold text-center'>frontend <br />javascript <br />tailwind <br />react</h2>

        </div>
        <div ref={star2Ref} className='relative top-32 right-[-480%] md:right-[-220%] xl:right-[-170%]'>
            <img className='w-52 h-52' src="/Image/download.svg" alt="" />
            <h2 className='absolute top-14 left-16 font-bold text-center'>frontend <br />javascript <br />tailwind <br />react</h2>

        </div>
        <div ref={star3Ref} className='relative top-72 right-[550%] md:right-[200%] xl:right-[100%]'>
            <img className='w-52 h-52' src="/Image/download.svg" alt="" />
            <h2 className='absolute top-14 left-16 font-bold text-center'>frontend <br />javascript <br />tailwind <br />react</h2>

        </div>
    </div>
  )
}

export default Animation